module.exports = __webpack_public_path__ + "static/img/dish-icon.8b92eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/dish-icon.png
// module id = 42vp
// module chunks = 7